module.exports = __webpack_public_path__ + "img/132w.465d92d.jpg";